const normalize = (key: string) => {
  // remove / at beginning or end
  return key.replace(/^\/|\/$/g, '')
}

export const generateStoryblokPageCacheKey = (accessToken: string, slug: string) => {
  return `storyblok-page-${accessToken}-${normalize(slug)}`
}

export const generateStoryblokLinksCacheKey = (accessToken: string, path: string) => {
  return `storyblok-links-${accessToken}-${normalize(path)}`
}
